export const SMALLEST_BREAKPOINT = 960;
export const MIDDLE_BREAKPOINT = 1024;
export const LARGEST_BREAKPOINT = 1280;

export const TRACKING_STATE_THRESHOLD_MED = 10;
export const TRACKING_STATE_THRESHOLD_MIN = 1;
export const TRACKING_STATE_THRESHOLD_BLURRY = 0;

export const TRACKING_STATE_DELIVERED = 'DELIVERED';
export const TRACKING_STATE_NOT_DELIVERED = 'NOT_DELIVERED';
export const TRACKING_STATE_OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY';
export const TRACKING_STATE_UNKNOWN = 'UNKNOWN';
export const TRACKING_STATE_BLOCKED = 'BLOCKED';
export const TRACKING_STATE_SHADOWED = 'SHADOWED';

export const JOBTYPE_PICKUP = 'PICKUP';
export const JOBTYPE_COLLECTION = 'COLLECTION';

export const TRACKING_STATE_PICKED_UP = 'PICKED_UP';
export const TRACKING_STATE_NOT_PICKED_UP = 'NOT_PICKED_UP';

export const TRACKING_STATE_COLLECTED = 'COLLECTED';
export const TRACKING_STATE_NOT_COLLECTED = 'NOT_COLLECTED';

export const TRACKING_DELIVERY_STATE_PRE_ETA = 'pre_eta';
export const TRACKING_DELIVERY_STATE_FAR = 'far';
export const TRACKING_DELIVERY_STATE_CLOSE = 'close';
export const TRACKING_DELIVERY_STATE_NEAR = 'near';
export const TRACKING_DELIVERY_STATE_LAST = 'last';
export const TRACKING_DELIVERY_STATE_UNCLEAR = 'unclear';

export const TRACKING_STATE_DETAIL_PARCEL_SHOP = 'PARCEL_SHOP';
export const TRACKING_STATE_DETAIL_NEIGHBOR = 'NEIGHBOR';

// delta in milliseconds
export const TRACKING_STATE_ETA_VALID_DELTA = -(15 * 60 * 1000); // 15 minutes past

export const NOTIFICATION_TYPE_ELIGIBLE = 'ELIGIBLE';
export const NOTIFICATION_TYPE_SET = 'SET';
export const DELIVER_TO_NEIGHBOUR = 'DELIVER_TO_NEIGHBOR';
export const DEPOSIT_PERMISSION = 'DEPOSIT_PERMISSION';
export const DELIVER_TO_PARCELSHOP = 'DELIVER_TO_PARCELSHOP';
export const ACTION_CUSTOMIZED_DELIVERY = 'customized_delivery';

export const ACTION_TYPE_INFO = 'info';
export const ACTION_TYPE_ERROR = 'error';

export const SESSION_STORAGE_GDPR_KEY = 'rtt.gdpr';
export const LOCAL_STORAGE_DELIVERY_PERIOD_KEY = 'rtt.deliveryPeriodBeta';
export const LOCAL_STORAGE_MOVING_CAR_KEY = 'rtt.movingCar';
export const LOCAL_STORAGE_DEBUG_WAYPOINTS_KEY = 'rtt.debugWaypoints';
export const ETA_DEVIATION_VERY_EARLY = 'VERY_EARLY';
export const ETA_DEVIATION_VERY_DELAYED = 'VERY_DELAYED';

export const DELIVERY_NOTE = 'HINT';

export const FADE_OUT_DURATION_MS = 600;
export const LAST_UPDATE_KEY = 'lastUpdate';

// Error ids exposed by the backend
// See: https://github.com/bettermile/rtt-backend/blob/main/src/main/kotlin/com/gls/rtt/parcel/rest/ParcelError.kt
export const ERROR_ID_UNKNOWN_TRACKING_ID = 'PARCEL-404';
export const ERROR_ID_POSTCODE_VERIFICATION_FAILED = 'PARCEL-1';
export const ERROR_ID_PARCEL_POSTCODE_RATE_LIMIT_REACHED = 'PARCEL-7';
